module.exports = __webpack_public_path__ + "img/image3.500dd6f5.png";